import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreensIcon4 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 800,
	height: 600,
	viewBox: "0 0 800 600",
	xmlns: "http://www.w3.org/2000/svg",
	"data-name": "Layer 1",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1",
		children: [
			/* @__PURE__ */ _jsx("title", { children: "Layer 1" }),
			/* @__PURE__ */ _jsx("path", {
				id: "svg_2",
				d: "m450,100.00001c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,100.00001c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-100.00001z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "svg_3",
				d: "m50,100.00001c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,100.00001c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-100.00001z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "svg_4",
				d: "m450,400c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,100c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-100z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "svg_5",
				d: "m50,400c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,100c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-100z"
			})
		]
	})
});
export { SvgScreensIcon4 as ReactComponent };
